import { render } from "./EntityFabric.vue?vue&type=template&id=267bf037&ts=true"
import script from "./EntityFabric.vue?vue&type=script&lang=ts"
export * from "./EntityFabric.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__